import { useCallback, useEffect } from 'react';
import useDialog from '@/components/organisms/useDialog';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';

export const useClipListPopover = () => {
  const { isOpen: isClipListPopoverOpen, openDialog, closeDialog } = useDialog();

  const toggleClipListPopover = useCallback(
    ({ isOpen }: { isOpen: boolean }) => {
      if (isOpen) {
        openDialog();
        return;
      }
      closeDialog();
    },
    [openDialog, closeDialog]
  );

  useEffect(() => {
    const eventListener = EventBus.on(CustomEvents.ClipListPopUp, toggleClipListPopover);
    return () => {
      EventBus.off(CustomEvents.ClipListPopUp, eventListener);
    };
  }, [toggleClipListPopover]);

  return {
    isClipListPopoverOpen,
    closeDialog
  };
};
